import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';
import { categoriesData, getArticlesByCategory, getCategoryBySlug } from '@/mocks/categoryData';

const categoryArticleImages = [
  'https://readdy.ai/api/search-image?query=Digital%20security%20shield%20concept%20minimalist%20illustration%2C%20warm%20coral%20amber%20gradient%20background%2C%20clean%20professional%20aesthetic%2C%20abstract%20protection%20symbol&width=800&height=500&seq=cat-card-01&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Login%20authentication%20user%20guide%20concept%20illustration%2C%20minimalist%20digital%20key%20icon%2C%20warm%20professional%20design%2C%20coral%20accents%20on%20neutral%20background&width=800&height=500&seq=cat-card-02&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Official%20announcement%20megaphone%20concept%2C%20minimalist%20document%20with%20stamp%20illustration%2C%20warm%20professional%20amber%20gold%20accents%20on%20clean%20background&width=800&height=500&seq=cat-card-03&orientation=landscape',
  'https://readdy.ai/api/search-image?query=FAQ%20customer%20support%20concept%20illustration%2C%20minimalist%20question%20mark%20and%20chat%20bubble%2C%20warm%20professional%20aesthetic%2C%20coral%20toned%20design&width=800&height=500&seq=cat-card-04&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Mobile%20phone%20access%20and%20digital%20technology%20concept%2C%20minimalist%20illustration%2C%20warm%20amber%20coral%20color%20scheme%2C%20clean%20professional%20design&width=800&height=500&seq=cat-card-05&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Beginners%20guide%20tutorial%20learning%20concept%2C%20minimalist%20book%20illustration%2C%20warm%20soft%20lighting%2C%20clean%20professional%20coral%20accents&width=800&height=500&seq=cat-card-06&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Cybersecurity%20network%20protection%20concept%2C%20abstract%20shield%20and%20data%20nodes%2C%20minimalist%20warm%20illustration%2C%20amber%20accents%20on%20neutral%20background&width=800&height=500&seq=cat-card-07&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Rumor%20debunking%20fact%20checking%20concept%2C%20minimalist%20magnifying%20glass%20illustration%2C%20warm%20professional%20design%2C%20coral%20accents&width=800&height=500&seq=cat-card-08&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Account%20protection%20security%20lock%20concept%2C%20abstract%20shield%20and%20key%20minimalist%20illustration%2C%20warm%20amber%20coral%20professional%20design&width=800&height=500&seq=cat-card-09&orientation=landscape',
];

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = getCategoryBySlug(slug || '');
  const articles = getArticlesByCategory(slug || '');

  if (!category) {
    return (
      <>
        <ScrollToTop />
        <Navbar />
        <main className="min-h-screen flex items-center justify-center pt-16">
          <div className="text-center">
            <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-full bg-secondary-100 mb-4">
              <i className="ri-error-warning-line text-2xl text-secondary-500"></i>
            </div>
            <h1 className="text-xl font-bold text-foreground-950 mb-2 font-heading">分类不存在</h1>
            <p className="text-sm text-foreground-500 mb-4">请检查分类地址是否正确</p>
            <Link to="/" className="text-sm font-medium text-primary-600 hover:text-primary-700 cursor-pointer">
              返回首页
            </Link>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main className="pt-16">
        <Breadcrumb
          items={[
            { label: '首页', path: '/' },
            { label: '分类导航', path: '/category/anquan' },
            { label: category.name },
          ]}
        />

        <section className="w-full px-4 md:px-6 py-8 md:py-12 bg-background-100/60">
          <div className="max-w-6xl mx-auto">
            <div className="mb-8">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600">
                  <i className={`${category.icon} text-xl`}></i>
                </div>
                <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
                  {category.name}
                </h1>
              </div>
              <p className="text-sm text-foreground-600 ml-13">{category.description}</p>
            </div>

            <div className="flex items-center gap-2 mb-8 flex-wrap">
              <span className="text-xs text-foreground-500 mr-2 whitespace-nowrap">分类切换：</span>
              {categoriesData.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className={`px-3 py-1.5 rounded-full text-xs font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                    cat.slug === slug
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-50 text-foreground-600 border border-background-200/70 hover:border-primary-300/50 hover:text-primary-600'
                  }`}
                >
                  {cat.name}
                </Link>
              ))}
            </div>

            {articles.length === 0 ? (
              <div className="text-center py-16">
                <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-secondary-100 mb-4">
                  <i className="ri-inbox-line text-xl text-secondary-500"></i>
                </div>
                <p className="text-foreground-500">该分类暂无文章</p>
              </div>
            ) : (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                {articles.map((article, index) => (
                  <Link
                    key={article.id}
                    to={`/article/${article.slug}`}
                    className="group rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200/60 overflow-hidden transition-all duration-300 cursor-pointer"
                  >
                    <div className="h-48 overflow-hidden">
                      <img
                        src={categoryArticleImages[index % categoryArticleImages.length]}
                        alt={article.title}
                        className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                        loading="lazy"
                      />
                    </div>
                    <div className="p-5">
                      <div className="flex items-center gap-3 mb-3">
                        <span className="px-2.5 py-1 text-xs font-medium rounded-full bg-accent-100 text-accent-700 whitespace-nowrap">
                          {article.category}
                        </span>
                        <span className="text-xs text-foreground-400 whitespace-nowrap">{article.date}</span>
                      </div>
                      <h3 className="text-base font-semibold text-foreground-950 mb-2 line-clamp-2 font-heading group-hover:text-primary-600 transition-colors">
                        {article.title}
                      </h3>
                      <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-4">
                        {article.excerpt}
                      </p>
                      <div className="flex items-center justify-between">
                        <span className="text-xs text-foreground-400 whitespace-nowrap">{article.readTime}</span>
                        <span className="text-xs font-medium text-primary-600 flex items-center gap-1 whitespace-nowrap">
                          阅读全文 <i className="ri-arrow-right-line text-xs"></i>
                        </span>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            )}
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}